import React from "react";
import { Dropdown, Collapse } from "antd";

const ContactCompanyInfo = ({
  companyName,
  contactName,
  phoneNumber,
  whatsappNumber,
  telegramNickname,
  okpo,
  inn,
  certificate,
  license,
  avatar,
  showTitle = true,
}) => {
  // Helper function to get initials from name
  const getInitials = (name) => {
    if (!name) return "";
    const words = name.split(" ");
    if (words.length >= 2) {
      return (
        words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase()
      );
    }
    return name.charAt(0).toUpperCase() + (name.charAt(1) || "").toUpperCase();
  };

  // Helper function to format image source
  const formatImageSrc = (imageSrc) => {
    if (!imageSrc) return null;
    return imageSrc.match(/\/media\//) !== null
      ? imageSrc
      : `data:image/jpeg;base64,${imageSrc}`;
  };

  return (
    <>
      {showTitle && (
        <div className="order-form__section__title">
          <span className="order-form__section__title__text">Контакты</span>
        </div>
      )}

      <div className="order-detail__section">
        <div className="order-detail__about">
          <div className="order-detail__about-company">
            {!avatar && (
              <div className="order-detail__about-company__icon">
                {companyName?.charAt(0).toUpperCase()}
              </div>
            )}
            {avatar && (
              <div
                className="order-detail__about-company__icon"
                style={{
                  background: avatar
                    ? `url(${avatar}) no-repeat center center / cover`
                    : "#FFC107",
                  boxShadow: "rgba(34, 60, 80, 0.2) 0px 0px 16px 7px",
                }}
              ></div>
            )}
            <div className="order-detail__about-company__name">
              {companyName}
            </div>
          </div>

          <div className="order-detail__about-person">
            <div className="order-detail__about-person__icon">
              {getInitials(contactName || companyName)}
            </div>
            <div className="order-detail__about-person__name">
              {contactName || companyName}
            </div>

            <Dropdown
              placement="topRight"
              trigger={["click"]}
              dropdownRender={() => (
                <div className="order-detail__about-person__contacts-dropdown">
                  <div className="contact-item">
                    <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                  </div>
                  {whatsappNumber && (
                    <div className="contact-item">
                      <div
                        className="order-detail__about-person__contacts__whatsapp"
                        onClick={() =>
                          window.open(
                            `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, "")}`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  )}
                  {telegramNickname && (
                    <div className="contact-item">
                      <div
                        className="order-detail__about-person__contacts__telegram"
                        onClick={() =>
                          window.open(
                            `https://t.me/${telegramNickname.replace("@", "")}`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            >
              <div className="order-detail__about-person__call-icon" />
            </Dropdown>
          </div>
        </div>

        <br />

        <div className="order-detail__section">
          {okpo && (
            <div className="order-detail__section__item">
              <div className="order-detail__section__item__label">ОКПО:</div>
              <div className="order-detail__section__item__value">{okpo}</div>
            </div>
          )}
          {inn && (
            <div className="order-detail__section__item">
              <div className="order-detail__section__item__label">ИНН:</div>
              <div className="order-detail__section__item__value">{inn}</div>
            </div>
          )}
        </div>

        {/* Documents Collapse */}
        <div className="order-detail__section">
          <div className="order-form__section__title">
            <span className="order-form__section__title__text">Документы</span>
          </div>
          <Collapse
            items={[
              {
                key: "1",
                label: (
                  <div
                    className="order-detail__section__item"
                    style={{ marginBottom: 0 }}
                  >
                    <div className="order-detail__section__item__label">
                      <strong>Свидетельство о регистрации</strong>
                    </div>
                  </div>
                ),
                children: (
                  <div className="order-detail__documents">
                    {certificate ? (
                      <div className="order-detail__document-img">
                        <img
                          src={formatImageSrc(certificate)}
                          alt="Сертификат"
                        />
                      </div>
                    ) : (
                      <p>Сертификат отсутствует</p>
                    )}
                  </div>
                ),
              },
              {
                key: "2",
                label: (
                  <div
                    className="order-detail__section__item"
                    style={{ marginBottom: 0 }}
                  >
                    <div className="order-detail__section__item__label">
                      <strong>Лицензия</strong>
                    </div>
                  </div>
                ),
                children: (
                  <div className="order-detail__documents">
                    {license ? (
                      <div className="order-detail__document-img">
                        <img src={formatImageSrc(license)} alt="Лицензия" />
                      </div>
                    ) : (
                      <p>Лицензия отсутствует</p>
                    )}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default ContactCompanyInfo;
